import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 800,
    borderTop: '4px solid #f39c12',
    margin: 'auto',
    padding: '20px 0',
  },
  pos: {
    marginBottom: 12,
  },
});

export default function OutlinedCard() {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant='outlined'>
      <CardContent>
        <Typography variant='h5' component='h2' className={classes.pos}>
          Warning
        </Typography>
        <Typography>
        Although electrical / mechanical energy ('work') and chemical / thermal energy ('heat') have the same units, they are not the same thing.
        </Typography>
      </CardContent>
    </Card>
  );
}
